export const common = {
  // Navigation
  home: 'Home',
  services: 'Services',
  book: 'Book',
  contact: 'Contact',
  
  // Common actions
  reserve: 'Book Now',
  quote: 'Get Quote',
  startNow: 'Start Now',
  sendMessage: 'Send Message',
  sendReservation: 'Send Reservation',
  
  // Service categories
  all: 'All',
  residential: 'Residential',
  commercial: 'Commercial',
  specialized: 'Specialized',
  
  // Features
  qualityGuarantee: 'Quality Guarantee',
  punctuality: 'Punctuality',
  trainedStaff: 'Trained Staff',
  ecoProducts: 'Eco Products',
  
  // Feature descriptions
  satisfactionGuaranteed: '100% satisfaction guaranteed',
  alwaysOnTime: 'Always on time',
  experiencedProfessionals: 'Experienced professionals',
  environmentallyCare: 'We care for the environment',
  
  // Payment
  payAfterService: 'Pay after service',
  payAfterServiceNote: 'You don\'t need to pay now. Pay comfortably when we have finished your cleaning service.',
  
  // Contact info
  phoneOnly: 'Text messages only',
  location: 'United States',
  
  // Form labels
  fullName: 'Full name',
  email: 'Email',
  phone: 'Phone',
  serviceAddress: 'Service address',
  additionalNotes: 'Additional notes',
  serviceType: 'Service type',
  additionalMessage: 'Additional message',
  
  // Form placeholders
  fullNamePlaceholder: 'Your full name',
  emailPlaceholder: 'your@email.com',
  phonePlaceholder: '+1 555 123 4567',
  notesPlaceholder: 'Special instructions, property access, etc.',
  messagePlaceholder: 'Tell us more details about the service you need...',
  
  // Validation
  requiredFields: 'Please complete all required fields',
  charactersLimit: 'characters',
  
  // Status messages
  reservationSent: 'Reservation sent successfully! We will contact you soon to confirm.',
  messageSent: 'Message sent successfully! We will contact you soon.',
  errorSending: 'Error sending. Please try again.',
  sending: 'Sending...',
  
  // Time and date
  selectDate: 'Select date',
  selectTime: 'Select time',
  duration: 'Duration',
  
  // Summary
  summary: 'Reservation Summary',
  service: 'Service',
  basePrice: 'Base price',
  extraRooms: 'Extra rooms',
  extraBathrooms: 'Extra bathrooms',
  date: 'Date',
  time: 'Time',
  total: 'Total',
  
  // Additional info
  includes: 'Includes',
  whyChooseUs: 'Why choose us?',
  readyForCleanSpace: 'Ready for a spotless space?',
  bookToday: 'Book your cleaning service today and enjoy a clean and healthy environment',
  
  // Contact page
  contactUs: 'Contact Us',
  contactSubtitle: 'We are here to help you with all your cleaning services',
  requestQuote: 'Request Your Quote',
  needImmediateResponse: 'Need immediate response?',
  whatsappContact: 'Contact us on WhatsApp for quick assistance',
  writeWhatsApp: 'Write on WhatsApp'
};